import React from 'react';
import PropTypes from 'prop-types';
import { FormGroup, FormLabel, FormInput, FormError } from './styles';

export const FormField = ({
    name,
    type,
    value,
    onChange,
    required,
    requiredError,
    validation,
    validationError,
    touched,
    columns,
    ...rest
}) => (
        <FormGroup>
            <FormLabel htmlFor={name}>
                {name}{required && '*'}
            </FormLabel>
            <FormInput name={name}
                type={type}
                value={value}
                onChange={e => onChange(e.target.value)}
                required={required}
                error={
                    validation && touched && (!validation.required || !validation.pattern)
                }
                {...rest}
            />
            {validation &&
                touched &&
                !validation.required && <FormError className='error-message'>{requiredError}</FormError>}

            {validation &&
                touched &&
                validation.required &&
                !validation.pattern && (
                    <FormError>{validationError}</FormError>
                )}

        </FormGroup>
    );

FormField.propTypes = {
    name: PropTypes.string.isRequired,
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    required: PropTypes.bool,
    requiredError: PropTypes.string,
    validation: PropTypes.object,
    validationError: PropTypes.string,
    touched: PropTypes.bool
};

export default FormField;


// WEBPACK FOOTER //
// ./src/components/Form/FormField.js